<template>
  <div class="bg">
    <div class="bigTitle">
      Industry Expertise
    </div>
    <div class="SolutionsBox">
      <div class="introduce">
        <div class="introduceBG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/solutionsBG.png" alt=""></div>
        <div class="introduceBox">
          <div style="position: relative;">
            <div class="introduceIMG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/Industry Expertise/Industry_Healthcare.png" alt=""></div>
            <div class="summary">
              <div>
                <div class="title">Healthcare</div>
                <div class="value">
                  For nearly 10 years，Holden Healthcare has been a leader in Healthcare market research in Asia. Holden works directly with market research agencies and consultancies outside Asia, to support pharmaceutical and medical device companies in making decisions that affect healthcare outcomes around the region.

                </div>
                <div class="button">
                  <el-button type="primary" @click="toPath('/contact?source=healthcare')">REQUEST A BID</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SolutionsBox">
      <div class="introduce">
        <div class="introduceBG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/solutionsBG.png" alt=""></div>
        <div class="introduceBox">
          <div style="position: relative;">
            <div class="introduceIMG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/Industry Expertise/Industry_MedTech.png" alt=""></div>
            <div class="summary">
              <div>
                <div class="title"> MedTech</div>
                <div class="value">
                  We support our MedTech clients’ success in by providing comprehensive research solutions in Asia, including both quantitative and qualitative studies, modeling & analytics, and consulting services.

                </div>
                <div class="button">
                  <el-button type="primary" @click="toPath('/contact?source=medTech')">REQUEST A BID</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SolutionsBox">
      <div class="introduce">
        <div class="introduceBG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/solutionsBG.png" alt=""></div>
        <div class="introduceBox">
          <div style="">
            <div class="introduceIMG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/Industry Expertise/Industry_Consumers.png" alt=""></div>
            <div class="summary">
              <div>
                <div class="title">Consumer</div>
               <div class="value">
          Given the fast-paced economic development of many Asian markets, Holden provides you consumer insight for your product development, marketing efficiency, consumer segmentation, and experience management.

        </div>
                <div class="button">
                  <el-button type="primary" @click="toPath('/contact?source=industryConsumer')">REQUEST A BID</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path
      });
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "industry",
          source: "",
          information: ""
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "industry",
          source: this.$route.query.source,
          information: ""
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Nunito";
  color: #fff;
}
.bg {
  background-image: url(https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/Solutions_Background.png);
  background-size: cover;
}
.bigTitle {
  font-size: 60px;
  font-weight: 700;
  text-align: center;
  padding-top: 120px;
  padding-bottom: 50px;
}
.SolutionsBox {
  .introduce {
    position: relative;
    height: 750px;
    margin: 0 120px;
    .introduceBG {
      position: absolute;
      right: 6%;
      img {
        width: 100%;
      }
    }
    .introduceBox {
      position: absolute;
      left: 6%;

      // width: 100%;
      .introduceIMG {
        img {
          width: 100%;
        }
      }
      .summary {
        position: absolute;
        top: 0;
        padding: 0px 120px;
        height: 100%;
        display: flex;
        align-items: center;
        .title {
          font-size: 40px;
          font-weight: 700;
          // margin-top: 70px;
          margin-bottom: 50px;
        }
        .value {
          width: 70%;
          font-size: 20px;
        }
        .button {
          margin-top: 15px;
          button {
            background-color: #90bef9;
            border: none;
          }
        }
      }
    }
  }
}

// @media screen and (max-width: 576px) {
//   .bigTitle {
//     font-size: 80px;
//   }
//   .box {
//     flex-wrap: wrap;
//     .value {
//       width: 100%;
//       padding: 30px;
//       margin-bottom: 20px;
//       padding-bottom: 150px;
//       .title {
//         font-size: 75px;
//       }
//       .img {
//         width: 500px;
//         img {
//           width: 1000px;
//         }
//       }
//       .text {
//         font-size: 70px;
//       }
//       .more {
//         font-size: 70px;
//       }
//     }
//   }
// }
</style>